// blog data

export const Blogs = [
    {
        id:1,
        name:"I Lost 4 Months of Work the Night Before My Project Presentation (Thanks to AI Hallucination)",
        tags:["Ai Hallucination", "Github", "AI Agent", "Full Stack Developer"],
        date:"15 Feb, 2026",
        imgSrc:"https://www.robinwieruch.de/logo.svg",
        link:"hhttps://medium.com/@anveshsrivastava9/i-lost-4-months-of-work-the-night-before-my-project-presentation-thanks-to-ai-hallucination-e33b136ef2c8"
    },
    {
        id:2,
        name:"Learn for JavaScript Developers",
        tags:["react","styled-components"],
        date:"5 July, 2021",
        imgSrc:"https://codebucks.hashnode.dev/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1625479747640%2F7KzwP9nmj.png%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75",
        link:"https://overreacted.io/lean-for-javascript-developers/"
    },
    {
        id:3,
        name:"Life has trade-offs. So does every good system",
        tags:["System Design Concepts", "Life Lessons", "Software Engineering", "Student Life", "Self Improvement"],
        date:"12 Aug, 2026",
        imgSrc:"",
        link:"https://medium.com/@urayushjain/life-has-trade-offs-so-does-every-good-system-18d1715923c3"
    },
    {
        id:4,
        name:"What are Callbacks, Promises, and Async and Await in Javascript?",
        tags:["JavaScript","TypeScript"],
        date:"26 May, 2021",
        imgSrc:"https://learn.innoskrit.in/content/images/2023/12/logo-dark.png",
        link:"https://learn.innoskrit.in/blog/callbacks-promises-async-and-await-in-javascript/"
    },
    {
        id:5,
        name:"What is Higher Order Component (HOC) in React JS?",
        tags:["react","reactJS","web-development"],
        date:"3 Feb, 2021",
        imgSrc:"https://media.geeksforgeeks.org/gfg-gg-logo.svg",
        link:"https://www.geeksforgeeks.org/reactjs/react-js-higher-order-components/"
    },
    {
        id:6,
        name:"How to implement Pagination Component in React from scratch",
        tags:["react","css"],
        date:"5 Jan, 2021",
        imgSrc:"https://codebucks.hashnode.dev/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1625240050668%2FGAya9b0XK.png%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75",
        link:"https://dev.to/mikegajdos/how-to-build-a-custom-pagination-component-in-reactjs-p37"

    },
   
    {
        id:7,
        name:"What is Redux ?",
        tags:["react","redux","javascript"],
        date:"16 May, 2021",
        imgSrc:"",
        link:"https://medium.com/swlh/what-is-redux-b16b42b33820"
    },
    {
        id:8,
        name:"How to create Sidebar navigation menu in ReactJS with react router and framer-motion",
        tags:["react","framer-motion","styled-components"],
        date:"26 May, 2021",
        imgSrc:"https://cdn.freecodecamp.org/platform/universal/fcc_primary.svg",
        link:"https://www.freecodecamp.org/news/create-a-fully-animated-sidebar/"
    },
  
] 